module.exports = __webpack_public_path__ + "static/media/eye2-white.b76230d2.svg";